import React from 'react';
import stringify from '../../../utils/stableStringify';
import AntLocalization from '../../../utils/AntLocalization.js';
import AntCondition from '../../../utils/AntCondition.js';
import AntAuth from '../../../utils/AntAuth.js';
import cs from '../../../utils/const';
import { AntGlobal, AntSession } from '../../../utils/AntContext';
import './index.scss';
import { ImExit } from 'react-icons/im';
import { IoCloseCircleOutline } from 'react-icons/io5';
import Button from 'devextreme-react/button';

export default function (props) {
    const appGlobal = AntGlobal();
    // const canCloseWindow = () => {
    //     return window.opener !== null || window.history.length > 1;
    // };

    // let _canCloseWindow = canCloseWindow();


    let isPOSOnly = AntCondition.isValid(null, {
        whenUser: {
            UI_display_mode: 'POS_ONLY'
        }
    });
    if (isPOSOnly) {
        var userGroupCode = AntAuth.getSessionInfo('user_group_code');
        if (userGroupCode === 'Admin') isPOSOnly = false;
    }

    return (
        <div className={'pos-user-user-action-panel'}>
            {/* {_canCloseWindow && (
                <Button
                    height={'100%'}
                    stylingMode={'text'}
                    onClick={async () => {
                        // if (document.fullscreenElement) {
                        //     await document.exitFullscreen();
                        // }
                        // window.open('', '_self', '');
                        window.close();
                    }}
                    className={'pos-user-actions'}
                >
                    <div className={'pos-user-action'}>
                        <IoCloseCircleOutline className={'pos-user-action-icon'} />
                        <div className={'pos-user-action-name'}>{AntLocalization.translateText({ vi: 'Đóng cửa sổ', en: 'Close Window', fr: 'Fermer la fenêtre', es: 'Cerrar ventana', id: 'Tutup Jendela', ja: 'ウィンドウを閉じる', zh: '关闭窗口', ko: '창 닫기', hi: 'विंडो बंद करें', ar: 'إغلاق النافذة' })}</div>
                    </div>
                </Button>
            )} */}
            {!isPOSOnly && (
                <Button
                    height={'100%'}
                    stylingMode={'text'}
                    onClick={() => {
                        var uiData = localStorage.getItem(cs.System_Code + '-ui-states');
                        if (uiData) uiData = JSON.parse(uiData);
                        if (!uiData) uiData = {};

                        localStorage.setItem(
                            cs.System_Code + '-ui-states',
                            String(
                                stringify({
                                    ...uiData,
                                    mode: 'WebUI'
                                })
                            )
                        );
                        AntAuth.refreshToken(false, null, () => {
                            window.location.reload();
                        });
                    }}
                    className={'pos-user-actions'}
                >
                    <div className={'pos-user-action'}>
                        <img className={'pos-user-action-icon pos-user-action-switch-mode-icon'} src={appGlobal.appAssets.icons.icon_sale} />
                        <div className={'pos-user-action-name'}>{AntLocalization.translateText({ vi: 'Quản trị', en: 'Office Mode', fr: 'Mode Bureau', es: 'Modo Oficina', id: 'Mode Kantor', ja: 'オフィスモード', zh: '办公模式', ko: '오피스 모드', hi: 'ऑफिस मोड', ar: 'وضع المكتب' })}</div>
                    </div>
                </Button>
            )}
            <Button
                height={'100%'}
                stylingMode={'text'}
                onClick={() => {
                    AntAuth.logOut();
                }}
                className={'pos-user-actions'}
            >
                <div className={'pos-user-action'}>
                    <ImExit className={'pos-user-action-icon'} />
                    <div className={'pos-user-action-name'}>{AntLocalization.translateText({ vi: 'Đăng xuất', en: 'Log Out', fr: 'Déconnexion', es: 'Cerrar sesión', id: 'Keluar', ja: 'ログアウト', zh: '登出', ko: '로그아웃', hi: 'लॉग आउट', ar: 'تسجيل الخروج' })}</div>
                </div>
            </Button>
        </div>
    );
}
